<template>
  <v-app-bar app color="#424949" dark>
    <span class="title">{{
      $store.state.idInstitucion ? $store.state.nombreInstitucion : "Tokia Play"
    }}</span>

    <!-- <v-toolbar-title>GesMed</v-toolbar-title> -->

    <v-spacer></v-spacer>

    <v-btn icon :href="facebookUrl" target="_blank">
      <v-icon>mdi-facebook</v-icon>
    </v-btn>

    <v-btn
      v-if="$store.state.idInstitucion !== 410"
      icon
      href="https://www.instagram.com/sigemedok/"
      target="_blank"
    >
      <v-icon>mdi-instagram</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
export default {
  computed: {
    facebookUrl() {
      return this.$store.state.idInstitucion === 410
        ? "https://www.facebook.com/cotbahia"
        : "https://www.facebook.com/sigemed/";
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: 600;
  font-size: 1.5rem;
}
</style>
